import { render, staticRenderFns } from "./LockRequests.vue?vue&type=template&id=4d8b6026&"
import script from "./LockRequests.vue?vue&type=script&lang=js&"
export * from "./LockRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports